export default "__VITE_ASSET__G8jkbNNw__"